import { isSet } from './is-set';

export const getZoomLevel = (
  street?: string,
  zip?: string,
  locality?: string,
  country?: string
) => {
  if (isSet(zip) && isSet(locality) && isSet(country)) {
    return 15;
  }

  if (isSet(locality) || isSet(zip)) {
    return 10;
  }

  if (isSet(country)) {
    return 5;
  }

  if (isSet(street)) {
    return 15;
  }

  return 1;
};
